import { render } from "./PrecinctListComponent.vue?vue&type=template&id=84e51d90"
import script from "./PrecinctListComponent.vue?vue&type=script&lang=js"
export * from "./PrecinctListComponent.vue?vue&type=script&lang=js"

import "./PrecinctListComponent.vue?vue&type=style&index=0&id=84e51d90&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__